module.exports = __webpack_public_path__ + "img/sidebar_img_vl.a5cfb14d.jpg";